import React from "react";
import HeroPage from "../Components/HeroPage/HeroPage";
import Functionality from "../Components/Functionality/Functionality";
import JoinTrend from "../Components/JoinTrend/JoinTrend";
import MasterCard from "../Components/MasterCard/MasterCard";
import Authentication from "../Components/Authentication/Authentication";
import InvestedMarquee from "../Components/Marquee/InvestedMarquee";
const LandingPage = () => {
  return (
    <>
      <HeroPage />
      <Functionality />
      <JoinTrend />
      <InvestedMarquee />
      <MasterCard />
      <Authentication />
    </>
  );
};

export default LandingPage;
